<template>
  <Frame>
    <PageHeader :title="$t('salSalesOrder.orderSearch')" :hasBack="false" />
    <div class="list-contain">
      <div class="head-contain">
        <div class="filter-contain" style="width: 34%;">
          <span style="min-width: 78px;">{{ $t('salSalesOrderDetail.BillDate') }}</span>
          <el-date-picker v-model="rangeDate" type="daterange" size="small" range-separator="~"
            :start-placeholder="$t('comm.startdate')" :end-placeholder="$t('comm.enddate')"
            :picker-options="PickerOptions" :unlink-panels="true" @change="changeTime()"></el-date-picker>
        </div>

        <div class="filter-contain" style="width: 27%;">
          <span style="min-width: 85px;">{{ $t('salSalesOrderDetail.messagenumber') }}</span>
          <el-input v-model="BillNo" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain" style="width: 21%;">
          <span style="min-width: 42px;">{{ $t('salSalesOrder.customerNoLab') }}</span>
          <el-input v-model="customerPayNo" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain" style="width: 34%;">
          <span style="min-width: 78px;">ItemCode：</span>
          <el-input v-model="materialId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain" style="width: 27%;">
          <span style="min-width: 85px;">ItemName：</span>
          <el-input v-model="materialName" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain" style="width: 21%;">
          <span style="min-width: 42px;">OR：</span>
          <el-input v-model="Or" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div style="width:15%">
          <span style="width: 100%;display: flex; justify-content: flex-end;height: 32px;">
            <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
            <el-button type="primary" @click="GetListData(0)">{{ $t('button.query') }}</el-button>
          </span>
        </div>
      </div>
    </div>
    <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%"
      @selection-change="handleSelectionChange" v-loading="tableLoading">
      <el-table-column type="selection" fixed></el-table-column>
      <el-table-column type="index" width="50" :label="$t('orderImport.rowNo')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_SupId', tableData)" prop="X_SupId" :label="$t('salSalesOrder.supplier')"></el-table-column>
      <el-table-column :min-width="WidthControl('BillDate', tableData)" prop="BillDate" :label="$t('salSalesOrderDetail.messagedate')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_NewDate', tableData)" prop="X_NewDate" :label="$t('salSalesOrder.newDate')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_PreDate', tableData)" prop="X_PreDate" :label="$t('salSalesOrder.preDate')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_CustNumberOrg', tableData)" prop="X_CustNumberOrg" :label="$t('salSalesOrder.customerNo')"></el-table-column>
      <el-table-column :min-width="WidthControl('BillNo', tableData)" prop="BillNo" :label="$t('salSalesOrder.BillNo')">
        <template scope="scope">
          <el-link :underline="false" @click="viewOrderDetail(scope.row)">{{ scope.row.BillNo }}</el-link>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('X_Or', tableData)" prop="X_Or" label="OR"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialId', tableData)" prop="X_BPMaterialId" label="ItemCode"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialName', tableData)" prop="X_BPMaterialName" label="ItemName"></el-table-column>
      <el-table-column min-width="70" prop="X_TotalSQty" align="right" :label="$t('salSalesOrder.totalSQty')"></el-table-column>
      <el-table-column :min-width="WidthControl('OAmountWithTax', tableData)" prop="OAmountWithTax" align="right" :label="$t('salSalesOrder.strPrice')"></el-table-column>
      <el-table-column width="80" prop="CurrentState" :label="$t('salSalesOrder.CurrentState')">
        <template slot-scope="scope">
          <span v-if="scope.row.CurrentState == 1">{{ $t('salSalesOrder.unefficient') }}</span>
          <span v-else-if="scope.row.CurrentState == 2">{{ $t('salSalesOrder.efficient') }}</span>
          <span v-else-if="scope.row.CurrentState == 4">{{ $t('salSalesOrder.closed') }}</span>
        </template>
      </el-table-column>
      <el-table-column :min-width="WidthControl('X_UrgentResult', tableData)" prop="X_UrgentResult" :label="$t('salSalesOrder.urgentResult')"></el-table-column>
      <el-table-column width="110" prop="X_UrgentDealStateName" :label="$t('salSalesOrder.urgentDealStateName')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_LateOrderReason', tableData)" prop="X_LateOrderReason" :label="$t('salSalesOrder.lateOrderReason')"></el-table-column>
      <el-table-column :min-width="WidthControl('X_NoDelDateReason', tableData)" prop="X_NoDelDateReason" :label="$t('salSalesOrder.noDelDateReason')"></el-table-column>
      <el-table-column width="140" prop="X_UrgentShipStateName" :label="$t('salSalesOrder.urgentShipStateName')"></el-table-column>
      <el-table-column width="140" prop="X_LateOrderExpDate" :label="$t('salSalesOrder.lateOrderExpDate')"></el-table-column>
      <el-table-column :label="$t('salDispatchList.operation')">
        <template slot-scope="scope">
          <el-button class="topbutton" size="mini" type="text" @click="viewOrderDetail(scope.row)">
            {{ $t('button.check') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer-contain">
      <div class="btnarray">
        <el-button type="primary" @click="DoApply(0)" :title="$t('salSalesOrder.urgentApplay')">{{
    $t('salSalesOrder.urgentApplay')
}}</el-button>
        <el-button type="primary" @click="DoApply(1)" :title="$t('salSalesOrder.urgentShipApplay')">{{
    $t('salSalesOrder.urgentShipApplay')
}}</el-button>
      </div>
      <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
      <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange"
        layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage" :total="totalCount"
        :page-size="pageSize"></el-pagination>
    </div>
  </Frame>
</template>
<script>
import { listMixin } from "@/agency/mixin/mixin.js";
import { datePickerOptions, handleShortDate } from "@/utils/handleDate";
export default {
  name: "SalSalesOrder",
  mixins: [listMixin],
  data() {
    return {
      ProgId: "salSalesOrder",
      PickerOptions: datePickerOptions(this),
      customerPayNo: "",
      tableHeight: window.innerHeight - 315,
      pagecount: 5,
      materialId:"",
      materialName: "",
      Or:"",
      selectData: []
    };
  },
  props: {
    GetListData: {
      type: Function,
      default: function (pageIndex, ...arg) {
        this.getListData(pageIndex, ...arg);
      }
    }
  },
  mounted() {
    this.frameOnResize(315);
  },
  created() {
    this.rangeDate = this.getMonthRange();
    this.startDate = handleShortDate(this.rangeDate[0], "From");
    this.endDate = handleShortDate(this.rangeDate[1], "To");
    this.GetListData(0);
  },
  methods: {
    handleSelectionChange(val) {
      this.selectData = val;
    },
    DoApply(type) {
      let actionName, field, fieldName, curPath;
      if (type == 0) {
        curPath = "/Home/UrgentApply";
        actionName = this.$t("salSalesOrder.urgentApplay");
        field = "UrgentDealState";
        fieldName = this.$t("salSalesOrder.urgentDealStateName");
      } else if (type == 1) {
        curPath = "/Home/ShipmentApply";
        actionName = this.$t("salSalesOrder.urgentShipApplay");
        field = "UrgentShipState";
        fieldName = this.$t("salSalesOrder.urgentShipStateName");
      }
      if (this.selectData.length == 0) {
        this.$store.commit("TIPPOP", {
          popType: "warning",
          popMessage: this.$t("salSalesOrder.unSelectTip")
        });
      } else if (this.selectData.length > 10) {
        this.$store.commit("TIPPOP", {
          popType: "warning",
          popMessage: this.$t("salSalesOrder.Select110Tip").replace("{0}", actionName)
        });
      } else {
        let errMsg = "";
        let billNos = [];
        for (let i = 0; i < this.selectData.length; i++) {
          let curD = this.selectData[i];
          let rowNo = this.tableData.indexOf(curD);
          if (curD["InventoryState"] == 2) {
            errMsg = this.$t("salSalesOrder.applyError1")
              .replace("{0}", rowNo + 1)
              .replace("{1}", curD["BillNo"])
              .replace("{2}", actionName);
            break;
          }
          if (curD[field] == "2") {
            errMsg = this.$t("salSalesOrder.applyError2")
              .replace("{0}", rowNo + 1)
              .replace("{1}", curD["BillNo"])
              .replace("{2}", fieldName)
              .replace("{3}", actionName);
            break;
          }
          if (curD["X_NewDate"] != "") {
            let nowTime = new Date().getTime();
            let newDateTime = new Date(curD["X_NewDate"]).getTime();
            if (newDateTime > nowTime) {
              let billDateTime = new Date(curD["BillDate"]).getTime();
              let totalSQty = parseInt(curD["X_TotalSQty"].replace(/,/g, ""));
              let dateSpan = (newDateTime - billDateTime) / 86400000;
              if (totalSQty <= 100 && dateSpan <= 5) {
                errMsg = this.$t("salSalesOrder.applyError3")
                  .replace("{0}", rowNo + 1)
                  .replace("{1}", curD["BillNo"]);
                break;
              }
              if (totalSQty > 100 && dateSpan <= 9) {
                errMsg = this.$t("salSalesOrder.applyError4")
                  .replace("{0}", rowNo + 1)
                  .replace("{1}", curD["BillNo"]);
                break;
              }
            }
          }
          billNos.push(curD["BillNo"]);
        }
        if (errMsg) {
          this.$store.commit("TIPPOP", {
            popType: "warning",
            popMessage: errMsg
          });
        } else {
          this.$router.push({
            path: curPath,
            query: {
              BillNos: billNos.join(';')
            }
          });
        }
      }
    },
    getMonthRange() {
      const today = new Date();
      const curYear = today.getFullYear();
      const curMonth = today.getMonth();
      const startMonth = new Date(curYear, curMonth, 1);
      startMonth.setHours(0, 0, 0, 0);
      const endMonth = new Date(curYear, curMonth + 1, 0);
      endMonth.setHours(0, 0, 0, 0);
      return [startMonth, endMonth];
    },
    changeTime() {
      this.getTime();
      //this.GetListData(0);
    },
    getListData(index) {
      this.selectData = [];
      this.pageIndex = index;
      this.tableLoading = true;
      this.axiosInvoke(
        this.sysHandlerUrl,
        {
          action: "getsalsalesorder",
          BillNo: this.BillNo,
          customerPayNo: this.customerPayNo,
          materialId: this.materialId,
          materialName: this.materialName,
          startDate: this.startDate,
          endDate: this.endDate,
          Or: this.Or,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        },
        res => {
          const data = res.data;
          this.tableLoading = false;
          this.tableData = data.DataTable;
          this.totalCount = data.totalCount;
        },
        false,
        true
      );
    },
    handleCurrentChange(page) {
      this.pageIndex = page - 1;
      this.GetListData(this.pageIndex);
    },
    pageSizeChange() {
      this.GetListData(0);
    },
    viewOrderDetail(row) {
      this.$router.push({
        path: "/Home/SalSalesOrderDetail",
        query: {
          BillNo: row.BillNo
        }
      });
    },
    reset() {
      this.baseReset();
      this.rangeDate = this.recentYears();
      this.startDate = handleShortDate(this.rangeDate[0], "From");
      this.endDate = handleShortDate(this.rangeDate[1], "To");
      this.customerPayNo = "";
      this.materialId = "";
      this.materialName = "";
      this.Or = "";
      this.GetListData(0);
    }
  }
};
</script>
<style scoped>
.list-contain {
  display: flex;
  padding: 10px 0px;
}

.head-contain {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.filter-contain {
  /* width: 24%; */
  padding-right: 1%;
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 10px;
}
.filter-contain>span {
  color: black;
  font-size: 14px;
  margin: auto;
  white-space: nowrap;
}

.el-button--reset{
  padding: 6px 18px;
}
.el-button--primary{
  padding: 6px 18px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.el-table{
  font-size: 12px;
  color: black;
}
.el-link{
  font-size: 12px;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
  padding-left: 5px;
}

.footer-contain {
  display: flex;
  padding-top: 6px;
  /* justify-content: center; */
}

.pagination {
  padding-top: 6px;
}

.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}

.el-table /deep/ thead {
  font-size: 14px;
  color: black;
}

.btnarray {
  width: 40%;
  margin-left: 7px;
}
</style>
